export type Size = 'medium' | 'large' | 'huge' | 'huge2';

export const matchSize =
    <T extends any>(matchers: Record<'medium', T> & Partial<Record<Exclude<Size, 'medium'>, T>>) =>
    (size: Size = 'medium'): T => {
        const match = matchers[size];
        if (match == null) {
            throw Error(`Missing size declaration: ${size}`);
        }
        return match;
    };

export type Status = 'error' | 'warning' | 'success';

export type Color = 'base' | 'primary' | 'secondary' | 'tertiary' | 'danger';
